module.exports = __webpack_public_path__ + "static/img/574_phase_function_Paper_PointsHejduk_Prediction.605c2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/574_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gSPC
// module chunks = 0